<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" width="150" />
      <el-table-column prop="admin_id" label="管理员id" width="150" />
      <el-table-column prop="admin_name" label="管理员名称" width="150" />
      <el-table-column prop="type" label="钱包类型" width="150">
        <template #default="scope">
          {{ getLabelByVal(scope.row.type, withdrawTypeEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="汇率" width="150" />
      <el-table-column label="详情" width="200">
        <template #default="scope">
          <div v-if="scope.row.type == 0">
            银行:{{ scope.row.bank_name }}<br />
            姓名:{{ scope.row.bank_owner }}<br />
            账号:{{ scope.row.bank_account }}<br />
            支行:{{ scope.row.bank_branch }}<br />
          </div>
          <div v-else-if="scope.row.type == 1">
            币名称:{{ scope.row.coin_name }}<br />
            币区块链:{{ scope.row.coin_blockchain }}<br />
            钱包地址:{{ scope.row.coin_account }}<br />
          </div>
          <div v-else-if="scope.row.type == 2 || scope.row.type == 3">
            账号:{{ scope.row.alipay_account }}<br />
          </div>
          <div v-else-if="scope.row.type == 4">
            收款人:{{ scope.row.bank_name }}<br />
            账号:{{ scope.row.bank_account }}<br />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="img" label="收款码" width="150">
        <template #default="scope">
          {{ scope.row.img ? "" : "--" }}
          <el-image
            v-if="scope.row.img"
            class="previewImg"
            :preview-teleported="true"
            :src="proxy.IMG_BASE_URL + scope.row.img"
            :zoom-rate="1.2"
            :max-scale="7"
            :min-scale="0.2"
            :preview-src-list="[proxy.IMG_BASE_URL + scope.row.img]"
            show-progress
            :initial-index="0"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="150" />
      <el-table-column prop="create_at" label="添加时间" width="160" />
      <el-table-column prop="update_at" label="更新时间" width="160" />

      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="新增/编辑" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { openEnums, withdrawTypeEnums, getLabelByVal } from "@/config/enums";
import EditPop from "./components/paymentAccount/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  title: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

onMounted(() => {
  getList();
});

const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const submitForm = async () => {
  const url =
    formType.value == "add"
      ? "PaymentAccount/addPaymentAccount"
      : "PaymentAccount/updatePaymentAccount";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      title: data.title,
      type: data.type,
      rate: data.rate,
      bank_owner: data.bank_owner,
      bank_name: data.bank_name,
      bank_branch: data.bank_branch,
      bank_account: data.bank_account,
      coin_name: data.coin_name,
      coin_account: data.coin_account,
      coin_blockchain: data.coin_blockchain,
      alipay_account: data.alipay_account,
      img: data.img,
      status: data.status,
      remark: data.remark,
      id: data.id,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "PaymentAccount/deletePaymentAccount?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/PaymentAccount/getPaymentAccountLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
